<template>
	<div v-show="!loading" class="login-form bg-light-green shadow-2">
		<div v-if="formSubmitted" class="spinner pull-right"></div><h2>Login</h2>
		<br>
		<div v-if="error"><p>{{error}}</p></div>

		<form @submit.prevent="validateBeforeSubmit" v-if="!formSubmitted">
			<div class="form-group" >
			    <label class="control-label" for="email">Email</label>
			    <input v-model="email" v-validate.initial="email" data-vv-rules="required|email" class="form-control" type="email" placeholder="Username">
			    <p class="text-danger" v-if="errors.has('email')">{{ errors.first('email') }}</p>
			</div>
			<div class="form-group">
			    <label class="control-label" for="password" >Password</label>
			    <input type="password" v-model="password" v-validate.initial="password" data-vv-rules="required" class="form-control" placeholder="password">
			    <p class="text-danger" v-if="errors.has('password')">{{ errors.first('password') }}</p>
			</div>
			<div class="form-group clearfix">
				<button class="button raised pull-right">Submit</button>
			</div>
		</form>
	</div>
</template>

<script>
import auth from '../services/auth.js'

export default{
	id: 'login',
	data () {
		return {
			password: '',
			email: '',
			formSubmitted: false
		}
	},
	methods: {
		validateBeforeSubmit (e) {
			this.$validator.validateAll()
			if (!this.errors.any()) {
				this.submitForm()
			}
		},
		submitForm: function () {
			this.formSubmitted = true
			var credentials = {
				un: this.email,
				pw: this.password
			}

			auth.login(this, credentials, 'home')
		}
	},
	computed: {
		loading () {
			return this.$store.state.app.loading
		}
	}
}
</script>

<style>
.login-form{
	width:500px;
	margin: 3rem auto;
	padding: 1rem;

}
.login-form h2{
	margin: 0;
}

</style>


// WEBPACK FOOTER //
// Login.vue?1d367150